var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification",class:_vm.setClass},[_c('div',{staticClass:"notification__title"},[_vm._v(_vm._s(_vm.setTitle))]),_c('p',{staticClass:"notification__message"},[_vm._v(_vm._s(_vm.setMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }